import React from 'react'
import cn, { Argument as ClassName } from 'classnames'
import styled from 'styled-components'

import { LandingMessageSuccessIcon } from '../landing-message-success-icon'
import { LandingMessageErrorIcon } from '../icons/landing-message-error-icon'
import { InfoIcon } from '../icons/info-icon'
import { theme } from '../theme'
import { FormHeader } from '../form-header'

const SWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const SIcon = styled.div`
    padding-bottom: 30px;
`

const SBody = styled.div`
    width: 550px;
    padding-bottom: 61px;
    line-height: 1.5em;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;

    @media (max-width: 576px) {
        width: 100%;
    }
`

const SLink = styled.a`
    &,
    &:hover,
    &:active,
    &:visited,
    &:focus {
        text-decoration: none;
        color: ${({ theme }) => theme.font.midDarkColor};
        cursor: pointer;
    }
`

export enum LandingMessageType {
    SUCCESS = 'success',
    ERROR = 'error',
    INFO = 'info',
}

export enum LandingMessageTitle {
    DEFAULT = 'MyChargeSpace',
    ADMIN = 'HaloAdmin',
}

export type LandingMessageProps = {
    title?: string | null | React.ReactNode
    type?: LandingMessageType
    linkText?: string
    onClick?: () => void
    children: React.ReactNode
    className?: ClassName
    style?: React.CSSProperties
    icon?: React.ReactNode
}

const renderIcon = (type?: LandingMessageType) => {
    if (type) {
        if (type === LandingMessageType.SUCCESS) {
            return <LandingMessageSuccessIcon />
        }
        if (type === LandingMessageType.ERROR) {
            return <LandingMessageErrorIcon />
        }

        return <InfoIcon size={90} fill={theme.brandColors.CA_Green} />
    }
}

export function LandingMessage({
    title,
    type,
    linkText,
    onClick,
    children,
    className,
    style,
    icon,
}: LandingMessageProps): React.ReactElement {
    return (
        <SWrapper className={cn(className)} style={style}>
            <FormHeader data-testid="header" className="mb-6" />
            <SIcon>{icon || renderIcon(type)}</SIcon>

            {title ? <h4 className="m-0 mb-3">{title}</h4> : null}

            <SBody>{children}</SBody>
            {linkText ? (
                <SLink onClick={onClick} data-testid="linkBtn">
                    {linkText}
                </SLink>
            ) : null}
        </SWrapper>
    )
}
